export const ErrorIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_2473_3641)">
      <path d="M9.99984 1.66669C5.3915 1.66669 1.6665 5.39169 1.6665 10C1.6665 14.6084 5.3915 18.3334 9.99984 18.3334C14.6082 18.3334 18.3332 14.6084 18.3332 10C18.3332 5.39169 14.6082 1.66669 9.99984 1.66669ZM13.5832 13.5834C13.2582 13.9084 12.7332 13.9084 12.4082 13.5834L9.99984 11.175L7.5915 13.5834C7.2665 13.9084 6.7415 13.9084 6.4165 13.5834C6.0915 13.2584 6.0915 12.7334 6.4165 12.4084L8.82484 10L6.4165 7.59169C6.0915 7.26669 6.0915 6.74169 6.4165 6.41669C6.7415 6.09169 7.2665 6.09169 7.5915 6.41669L9.99984 8.82502L12.4082 6.41669C12.7332 6.09169 13.2582 6.09169 13.5832 6.41669C13.9082 6.74169 13.9082 7.26669 13.5832 7.59169L11.1748 10L13.5832 12.4084C13.8998 12.725 13.8998 13.2584 13.5832 13.5834Z" />
    </g>
    <defs>
      <clipPath id="clip0_2473_3641">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
